import { Box, Button, Grid } from "@mui/material";
import { blue } from "@mui/material/colors";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import * as React from "react";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import ReactTableStyles from "./ReactTableStyles";
import IconTextButton from "../Buttons/IconTextButton";
import themeCreator from "@Themes/themeCreator";
import axiosInstance from "@API/axios";

export const CustomColumnToolbar = (
  column,
  filters,
  density,
  exports,
  csvFileName,
  search,
  applyFilter,
  onClick,
  exportUrl,
  exportOnClick
) => {
  const customTheme = themeCreator();

  return (
    <ReactTableStyles>
      <Grid container justifyContent="space-between">
        {((filters || column || density || exports) && (
          <Grid item>
            <Box className="filtersWrapper">
              {filters && (
                <Box className="toolbarLeftObject">
                  <GridToolbarFilterButton className="toolbarButton" />
                </Box>
              )}
              {column && (
                <Box className="toolbarLeftObject">
                  <GridToolbarColumnsButton className="toolbarButton" />
                </Box>
              )}
              {density && (
                <Box className="toolbarLeftObject">
                  <GridToolbarDensitySelector className="toolbarButton" />
                </Box>
              )}
              {exports && (
                <Box className="toolbarLeftObject">
                  <Button
                    variant="text"
                    onClick={exportOnClick}
                    size="small"
                    startIcon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        style={{ fill: blue[900] }}
                      >
                        <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z" />
                      </svg>
                    }
                    style={{
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize: "0.8125rem",
                    }}
                  >
                    Export
                  </Button>
                </Box>
              )}
            </Box>
          </Grid>
        )) || <Grid item></Grid>}
        {search && (
          <Grid item>
            <Box className="toolbarRightObject">
              <GridToolbarQuickFilter className="toolbarButton" />
            </Box>
          </Grid>
        )}
        {applyFilter && (
          <Grid item>
            <Box className="searchButton">
              <IconTextButton
                buttonText={"Add Filter"}
                Icon={SearchRoundedIcon}
                className="search-button"
                data-is-search-button="true"
                onClick={onClick}
              />
            </Box>
          </Grid>
        )}
      </Grid>
    </ReactTableStyles>
  );
};

export default function ReactTable({
  data,
  columns,
  checkboxSelection,
  disableRowSelectionOnClick,
  columnsEnable,
  filtersEnable,
  densityEnable,
  exportEnable,
  exportedFileName,
  searchBarEnable,
  pageSizeOptions,
  InitialPageSize,
  disableColumnMenu,
  height = "70vh",
  id,
  getRowClassName,
  className,
}) {
  const column = !!columnsEnable;
  const filters = !!filtersEnable;
  const density = !!densityEnable;
  const exports = !!exportEnable;
  const search = !!searchBarEnable;
  const sizeOptions = pageSizeOptions || [25, 50, 100];
  const pageSize = InitialPageSize || 25;
  return (
    <ReactTableStyles tableHeight={height}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <DataGrid
            sx={{
              "& .MuiPaper-root.MuiDataGrid-paper": {
                transform: "rotate(45deg)!important",
              },
            }}
            getRowId={id && ((row) => row[id])}
            className={`${className ? className : ""} tableHeight `}
            getRowClassName={(params) => {
              let className =
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "Mui-even"
                  : "Mui-odd";
              className += getRowClassName?.(params) ?? "";
              return className;
            }}
            classes={{
              root: "overrideRoot",
              cell: "overrideCell",
              columnHeader: "columnHeaderOverride",
              row: "overrideRow",
              virtualScroller: "overrideVirtualScroller",
            }}
            columns={columns}
            disableColumnMenu={disableColumnMenu}
            rows={data}
            slots={{
              toolbar: () =>
                CustomColumnToolbar(
                  column,
                  filters,
                  density,
                  exports,
                  exportedFileName,
                  search
                ),
            }}
            checkboxSelection={checkboxSelection}
            disableRowSelectionOnClick={disableRowSelectionOnClick}
            initialState={{
              pagination: {
                paginationModel: { pageSize: pageSize, page: 0 },
              },
            }}
            pageSizeOptions={sizeOptions}
          />
        </Grid>
      </Grid>
    </ReactTableStyles>
  );
}
